const env = process.env;
const ecomApi = env.ECOM_API ? env.ECOM_API : "";
const ecomGatewayProxyApi = env.ECOM_GATEWAY_PROXY_API
  ? env.ECOM_GATEWAY_PROXY_API
  : "";

export interface IEnvironmentService {
  ecom: string;
  ecomApi: string;
  ecomGatewayApi?: string;
  ecomGatewayProxyApi: string;
  ecomSearch?: string;
  ecomDigitalData?: string;
  ecomProductDetail?: string;
  tabSetsSubCategoriesUrl: string;
  getOrderApprovalsUrl: string;
  approveRejectOrderUrl: string;
  getCartItemsUrl: string;
  getUserBudgetUrl: string;
  getItemIndicatorsUrl: string;
  getTabSetsCategoriesUrl: string;
  getDeliveryNotificationsUrl: string;
  removeCartItemUrl: string;
  getBudgetTypeUrl: string;
  getDeliveryAddressesUrl: string;
  setShoppingLocationUrl: string;
  getShoppingLocationByZipCodeUrl: string;
  getProductAvailabilityUrl: string;
  saveWorkflowUrl: string;
  getInkAndTonerDevicesUrl: string;
  getInkAndTonerModelsUrl: string;
  getInkAndTonerPayloadUrl: string;
  getListItemsUrl: string;
  getListsUrl: string;
  selectListUrl: string;
  getDepartmentsUrl: string;
  getTypeAheadUrl: string;
  getCustomerInvoiceParametersUrl: string;
  getArContactUrl: string;
  getCustomerServiceUrl: string;
  wheresMyStuffUrl: string;
  isEcom?: boolean;
  apimUrl?: string;
  apimSubscriptionKey?: string;
  getEmployeeContactsUrl?: string;
  getShoppingLocationUrl: string;
  getNavigationTokensUrl: string;
  getPropsUrl: string;
  getConfigPropsUrl: string;
  publicUrl: string;
  getAddressFromRegCookieUrl: string;
  getLoginUrl: string;
  getLogoutUrl: string;
  getDigitalDataUrl: string;
  getPricedProductUrl: string;
  ecomPDP: string;
  ecomQuickOrder: string;
  ecomShoppingCart: string;
  ecomVnextUrl: string;
  ecomInFootprintStates: string;
  ecomDnBUrl: string;
  ecomDnBPropList: string;
  logCompanyMatchUrl: string;
}

const EnvironmentServiceFromProccessEnv: IEnvironmentService = {
  ecom: env.REACT_APP_ECOM || "",
  ecomApi: env.REACT_APP_ECOM_API || ecomApi,
  ecomGatewayApi: env.REACT_APP_ECOM_GATEWAY_API || env.ECOM_GATEWAY_API,
  ecomGatewayProxyApi: env.REACT_APP_ECOM_API
    ? env.REACT_APP_ECOM_API + env.REACT_APP_ECOM_GATEWAY_API
    : ecomApi + ecomGatewayProxyApi,
  ecomSearch: env.REACT_APP_ECOM_SEARCH || env.ECOM_SEARCH,
  ecomDigitalData: env.REACT_APP_ECOM_DIGITAL_DATA || env.ECOM_DIGITAL_DATA,
  ecomProductDetail:
    env.REACT_APP_ECOM_PRODUCT_DETAIL || env.ECOM_PRODUCT_DETAIL,
  tabSetsSubCategoriesUrl: env.REACT_APP_TABSETS_SUB_CATEGORIES || "",
  getOrderApprovalsUrl: env.REACT_APP_GET_ORDER_APPROVALS || "",
  approveRejectOrderUrl: env.REACT_APP_APPROVE_REJECT_ORDER || "",
  getCartItemsUrl: env.REACT_APP_GET_CART_ITEMS || "",
  getUserBudgetUrl: env.REACT_APP_GET_USER_BUDGET_URL || "",
  getItemIndicatorsUrl: env.REACT_APP_GET_ITEM_INDICATORS_URL || "",
  getTabSetsCategoriesUrl: env.REACT_APP_GET_TAB_SETS_CATEGORIES_URL || "",
  getDeliveryNotificationsUrl:
    env.REACT_APP_GET_DELIVERY_NOTIFICATIONS_URL || "",
  removeCartItemUrl: env.REACT_APP_REMOVE_CART_ITEM_URL || "",
  getBudgetTypeUrl: env.REACT_APP_GET_BUDGET_TYPE_URL || "",
  getDeliveryAddressesUrl: env.REACT_APP_GET_DELIVERY_ADDRESSES_URL || "",
  setShoppingLocationUrl: env.REACT_APP_SET_SHOPPING_LOCATION_URL || "",
  getShoppingLocationByZipCodeUrl:
    env.REACT_APP_GET_SHOPPING_LOCATION_BY_ZIP_CODE_URL || "",
  getProductAvailabilityUrl: env.REACT_APP_GET_PRODUCT_AVAILABILITY_URL || "",
  saveWorkflowUrl: env.REACT_APP_SAVE_WORKFLOW_URL || "",
  getInkAndTonerDevicesUrl: env.REACT_APP_GET_INK_AND_TONER_DEVICES_URL || "",
  getInkAndTonerModelsUrl: env.REACT_APP_GET_INK_AND_TONER_MODELS_URL || "",
  getInkAndTonerPayloadUrl: env.REACT_APP_GET_INK_AND_TONER_PAYLOAD_URL || "",
  getListItemsUrl: env.REACT_APP_GET_LIST_ITEMS_URL || "",
  getListsUrl: env.REACT_APP_GET_LISTS_URL || "",
  selectListUrl: env.REACT_APP_SELECT_LIST_URL || "",
  getDepartmentsUrl: env.REACT_APP_GET_DEPARTMENTS_URL || "",
  getTypeAheadUrl: env.REACT_APP_GET_TYPE_AHEAD_URL || "",
  getCustomerInvoiceParametersUrl:
    env.REACT_APP_GET_CUSTOMER_INVOICE_PARAMETERS_URL || "",
  getArContactUrl: env.REACT_APP_GET_AR_CONTACT_URL || "",
  getCustomerServiceUrl: env.REACT_APP_GET_CUSTOMER_SERVICE_URL || "",
  wheresMyStuffUrl: env.REACT_APP_WHERES_MY_STUFF_URL || "",
  isEcom:
    env.REACT_APP_IS_ECOM === undefined || env.REACT_APP_IS_ECOM === "true",
  apimUrl: env.REACT_APP_APIM_URL || "",
  getEmployeeContactsUrl: env.REACT_APP_GET_EMPLOYEE_CONTACTS_URL || "",
  getShoppingLocationUrl: env.REACT_APP_GET_SHOPPING_LOCATION_URL || "",
  getPropsUrl: env.REACT_APP_GET_PROPS || "",
  getNavigationTokensUrl: env.REACT_APP_GET_NAVIGATION_TOKENS_URL || "",
  getConfigPropsUrl: env.REACT_APP_GET_CONFIG_PROPS_URL || "",
  publicUrl: env.PUBLIC_URL || "",
  getAddressFromRegCookieUrl:
    env.REACT_APP_GET_ADDRESS_FROM_REG_COOKIE_URL || "",
  getLoginUrl: env.REACT_APP_GET_LOGIN_URL || "",
  getLogoutUrl: env.REACT_APP_GET_LOGOUT_URL || "",
  getDigitalDataUrl: env.REACT_APP_GET_DIGITAL_DATA_URL || "",
  getPricedProductUrl: env.REACT_APP_GET_PRICED_PRODUCT_URL || "",
  ecomPDP: env.REACT_APP_ECOM_PDP || "",
  ecomQuickOrder: env.REACT_APP_ECOM_QUICK_ORDER || "",
  ecomShoppingCart: env.REACT_APP_ECOM_SHOPPINGCART || "",
  ecomVnextUrl: env.REACT_APP_ECOM_VNEXT || "",
  ecomInFootprintStates: env.REACT_APP_ECOM_IN_FOOTPRINT_STATES || "",
  ecomDnBUrl: env.REACT_APP_ECOM_DNB_URL || "",
  ecomDnBPropList: env.REACT_APP_ECOM_DNB_PROP_LIST || "",
  logCompanyMatchUrl: env.REACT_APP_LOG_COMPANYMATCH_URL || "",
};

function setApiMUrl() {
  if (typeof window !== "undefined") {
    if (!window.process) {
      window.process = {} as any;
    }
    if (!window.process.env) {
      window.process.env = {} as any;
    }
    const url = EnvironmentService.get().apimUrl;
    if (url && !window.process.env.APIM_BASE_URL) {
      window.process.env.APIM_BASE_URL = url;
    }
  }
}

const EnvironmentService = {
  get: function () {
    return EnvironmentServiceFromProccessEnv;
  },
};
setApiMUrl();

export default EnvironmentService;
